/* eslint-disable */
import React, { useState } from 'react';
import { messageAPI } from '../../services/api';
import './QuoteModal.css';

const QuoteModal = ({ service, onClose, isOpen }) => {
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    serviceType: service?.title || '',
    quantity: '',
    urgency: 'normal',
    specifications: '',
    message: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleNextStep = () => {
    if (step === 1) {
      if (!formData.name || !formData.email || !formData.phone) {
        setError('Please fill in all required fields');
        return;
      }
      setError('');
      setStep(2);
    }
  };

  const handlePrevStep = () => {
    setStep(1);
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const messagePayload = {
        name: formData.name.trim(),
        email: formData.email.trim(),
        phone: formData.phone.trim(),
        subject: `Service Request: ${formData.serviceType}`,
        message: `
Service Type: ${formData.serviceType}
Quantity: ${formData.quantity || 'Not specified'}
Urgency: ${formData.urgency}
Company: ${formData.company || 'Not specified'}
Specifications: ${formData.specifications || 'None'}
Additional Details: ${formData.message || 'None'}
        `.trim(),
        service: formData.serviceType,
        priority: formData.urgency === 'urgent' ? 'high' : 'normal'
      };

      const response = await messageAPI.createMessage(messagePayload);

      if (response.success) {
        setSuccess('Quote request sent successfully! We will respond within 24 hours.');
        setTimeout(() => {
          onClose();
          setFormData({
            name: '',
            email: '',
            phone: '',
            company: '',
            serviceType: service?.title || service?.name ||'',
            quantity: '',
            urgency: 'normal',
            specifications: '',
            message: ''
          });
          setStep(1);
          setSuccess('');
        }, 2000);
      }
    } catch (err) {
      setError(err.message || 'Failed to send quote request. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="quote-modal-overlay" onClick={onClose}>
      <div className="quote-modal" onClick={e => e.stopPropagation()}>
        <button className="quote-modal-close" onClick={onClose}>
          <i className="ri-close-line"></i>
        </button>

        <div className="quote-modal-header">
          <div className="quote-modal-icon">
            <i className="ri-file-copy-line"></i>
          </div>
          <h2>Request a service/program</h2>
          <p>for {service?.title || service?.name || 'our services'}</p>
        </div>

        <div className="quote-progress">
          <div className={`progress-step ${step >= 1 ? 'active' : ''}`}>
            <span className="step-number">1</span>
            <span className="step-label">Contact Info</span>
          </div>
          <div className={`progress-line ${step >= 2 ? 'active' : ''}`}></div>
          <div className={`progress-step ${step >= 2 ? 'active' : ''}`}>
            <span className="step-number">2</span>
            <span className="step-label">Service Details</span>
          </div>
        </div>

        {error && (
          <div className="quote-modal-error">
            <i className="ri-error-warning-line"></i>
            <span>{error}</span>
          </div>
        )}

        {success && (
          <div className="quote-modal-success">
            <i className="ri-checkbox-circle-line"></i>
            <span>{success}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className="quote-modal-form">
          {step === 1 && (
            <div className="quote-form-step">
              <div className="form-group">
                <label>
                  <i className="ri-user-line"></i>
                  Full Name <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Tut"
                  required
                />
              </div>

              <div className="form-group">
                <label>
                  <i className="ri-mail-line"></i>
                  Email Address <span className="required">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="tut@example.com"
                  required
                />
              </div>

              <div className="form-group">
                <label>
                  <i className="ri-phone-line"></i>
                  Phone Number <span className="required">*</span>
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="+2119********"
                  required
                />
              </div>

              <div className="form-group">
                <label>
                  <i className="ri-building-line"></i>
                  Company/Organization
                </label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleInputChange}
                  placeholder="Optional"
                />
              </div>

              <div className="form-actions">
                <button type="button" className="btn-next" onClick={handleNextStep}>
                  Continue <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          )}

          {step === 2 && (
            <div className="quote-form-step">
              <div className="form-group">
                <label>
                  <i className="ri-capsule-line"></i>
                  Service Type
                </label>
                <input
                  type="text"
                  name="serviceType"
                  value={formData.serviceType}
                  onChange={handleInputChange}
                  readOnly
                  className="readonly-input"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>
                    <i className="ri-stack-line"></i>
                    Volume
                  </label>
                  <input
                    type="text"
                    name="quantity"
                    value={formData.quantity}
                    onChange={handleInputChange}
                    placeholder="e.g., 100"
                  />
                </div>

                <div className="form-group">
                  <label>
                    <i className="ri-time-line"></i>
                    Urgency
                  </label>
                  <select name="urgency" value={formData.urgency} onChange={handleInputChange}>
                    <option value="normal">Normal (3-5 days)</option>
                    <option value="urgent">Urgent (24-48 hours)</option>
                    <option value="emergency">Emergency (Same day)</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>
                  <i className="ri-file-list-line"></i>
                  Specifications
                </label>
                <textarea
                  name="specifications"
                  value={formData.specifications}
                  onChange={handleInputChange}
                  placeholder="Specific requirements, seeds, coverage, etc."
                  rows="3"
                ></textarea>
              </div>

              <div className="form-group">
                <label>
                  <i className="ri-chat-3-line"></i>
                  Additional Message
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  placeholder="Any other details you'd like to add..."
                  rows="2"
                ></textarea>
              </div>

              <div className="form-actions">
                <button type="button" className="btn-prev" onClick={handlePrevStep}>
                  <i className="ri-arrow-left-line"></i> Back
                </button>
                <button type="submit" className="btn-submit" disabled={isLoading}>
                  {isLoading ? (
                    <>
                      <i className="ri-loader-4-line spinning"></i>
                      Sending...
                    </>
                  ) : (
                    <>
                      Submit Request <i className="ri-send-plane-line"></i>
                    </>
                  )}
                </button>
              </div>
            </div>
          )}
        </form>

        <div className="quote-modal-footer">
          <div className="trust-badge">
            <i className="ri-shield-check-line"></i>
            <span>Your information is secure and confidential</span>
          </div>
          <div className="response-time">
            <i className="ri-time-line"></i>
            <span>Expected response within 24 hours</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteModal;